import { IEnvironment } from '@novu/shared';
import { get, post, put } from './api.client';

export type OutboundWebhookSettings = {
  url: string | null;
  enabled: boolean;
  events: string[];
  secret: string | null;
  availableEvents: string[];
  defaultEvents: string[];
};

export type OutboundWebhookTestResult = { ok: boolean; statusCode?: number; error?: string };

export async function getOutboundWebhookSettings({
  environment,
}: {
  environment: IEnvironment;
}): Promise<OutboundWebhookSettings> {
  const response = await get<{ data: OutboundWebhookSettings }>('/outbound-webhook-settings', { environment });

  return response.data;
}

export async function updateOutboundWebhookSettings({
  environment,
  settings,
}: {
  environment: IEnvironment;
  settings: { url?: string; enabled?: boolean; events?: string[] };
}): Promise<OutboundWebhookSettings> {
  const response = await put<{ data: OutboundWebhookSettings }>('/outbound-webhook-settings', {
    environment,
    body: settings,
  });

  return response.data;
}

export async function rotateOutboundWebhookSecret({
  environment,
}: {
  environment: IEnvironment;
}): Promise<OutboundWebhookSettings> {
  const response = await post<{ data: OutboundWebhookSettings }>('/outbound-webhook-settings/secret/rotate', {
    environment,
  });

  return response.data;
}

export async function testOutboundWebhook({
  environment,
}: {
  environment: IEnvironment;
}): Promise<OutboundWebhookTestResult> {
  const response = await post<{ data: OutboundWebhookTestResult }>('/outbound-webhook-settings/test', {
    environment,
  });

  return response.data;
}
